import { IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'Eloqua',
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Eloqua_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Eloqua_DisplayText)
    ]
})
export class EloquaLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_Endpoint
    })
    public endpoint?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName
    })
    public username?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public password?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_UseEncryptedEndpoints
    })
    public useEncryptedEndpoints?: boolean;

    @Metamodel.attribute({
        display: stringResources.ModelName_UseHostVerification
    })
    public useHostVerification?: boolean;

    @Metamodel.attribute({
        display: stringResources.ModelName_UsePeerVerification
    })
    public usePeerVerification?: boolean;

    public isLegacyConnector: boolean = true;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
